import { render } from "./CardPerfilMovil.vue?vue&type=template&id=01848436&scoped=true"
import script from "./CardPerfilMovil.vue?vue&type=script&lang=js"
export * from "./CardPerfilMovil.vue?vue&type=script&lang=js"

import "./CardPerfilMovil.vue?vue&type=style&index=0&id=01848436&lang=css&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-01848436"]])

export default __exports__